import React, { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import App from "./App";
import Login from "./pages/Login";
import Register from './pages/Register'
import Error from "./pages/Error";
import NotFound from "./pages/NotFound";
import ResetPassword from './pages/ResetPassword';
import ForgotPassword from './pages/ForgotPassword';
import VerifyRegistration from './pages/VerifyRegistration';

const AppWrapper = () => {
	const location = useLocation();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [location]);

	return <Routes>
		<Route path="/login" element={<Login />} />
		<Route path="/register" element={<Register />} />
		<Route path="/error" element={<Error />} />
		<Route path="/notfound" element={<NotFound />} />
		<Route path="/forgot-password" element={<ForgotPassword />} />
		<Route path="/reset-password/:userId" element={<ResetPassword />} />
		<Route path="/verify-registration/:userId" element={<VerifyRegistration />} />
		<Route path="/*" element={<App />} />
	</Routes>
}

export default AppWrapper;
